import {
    CLEAR_CURRENT_MODULECLE_CONTENT,
    CLEAR_MODULECLE_CONTENT_ERROR,
    CLEAR_MODULECLE_CONTENT_MESSAGE,
    CREATE_MODULECLE_CONTENT_FAIL,
    CREATE_MODULECLE_CONTENT_SUCCESS,
    DELETE_MODULECLE_CONTENT_FAIL,
    DELETE_MODULECLE_CONTENT_SUCCESS,
    GET_MODULECLE_CONTENT_FAIL,
    GET_MODULECLE_CONTENT_SUCCESS,
    GET_MODULECLE_CONTENTS_FAIL,
    GET_MODULECLE_CONTENTS_SUCCESS,
    REORDER_MODULECLE_CONTENTS_FAIL,
    REORDER_MODULECLE_CONTENTS_SUCCESS,
    SET_MODULECLE_CONTENT_ERROR,
    SET_MODULECLE_CONTENT_LOADING,
    UPDATE_MODULECLE_CONTENT_FAIL,
    UPDATE_MODULECLE_CONTENT_SUCCESS,
} from "../actions/moduleCleContentActions";

const initialState = {
    loading: false,
    error: null,
    message: null,
    items: [],
    currentContent: null,
    currentModuleCleId: null,
};

export default function moduleCleContentReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MODULECLE_CONTENT_LOADING:
            return { ...state, loading: action.payload };

        case SET_MODULECLE_CONTENT_ERROR:
            return { ...state, error: action.payload };

        case CLEAR_MODULECLE_CONTENT_ERROR:
            return { ...state, error: null };

        case CLEAR_MODULECLE_CONTENT_MESSAGE:
            return { ...state, message: null };

        case CLEAR_CURRENT_MODULECLE_CONTENT:
            return { ...state, currentContent: null };

        case GET_MODULECLE_CONTENTS_SUCCESS:
            return {
                ...state,
                items: action.payload.items || [],
                currentModuleCleId: action.payload.moduleCleId,
                error: null,
            };

        case GET_MODULECLE_CONTENT_SUCCESS:
            return {
                ...state,
                currentContent: action.payload || null,
                error: null,
            };

        case CREATE_MODULECLE_CONTENT_SUCCESS:
            return {
                ...state,
                currentContent: action.payload || null,
                message: "Contenu créé avec succès.",
                error: null,
            };

        case UPDATE_MODULECLE_CONTENT_SUCCESS:
            return {
                ...state,
                currentContent: action.payload || null,
                message: "Contenu mis à jour avec succès.",
                error: null,
            };

        case DELETE_MODULECLE_CONTENT_SUCCESS:
            return {
                ...state,
                currentContent:
                    state.currentContent?.id === action.payload.contentId ? null : state.currentContent,
                items: state.items.filter((item) => item.id !== action.payload.contentId),
                message: "Contenu supprimé avec succès.",
                error: null,
            };

        case REORDER_MODULECLE_CONTENTS_SUCCESS:
            return {
                ...state,
                items: action.payload.items || [],
                currentModuleCleId: action.payload.moduleCleId,
                message: "Ordre des contenus mis à jour.",
                error: null,
            };

        case GET_MODULECLE_CONTENTS_FAIL:
        case GET_MODULECLE_CONTENT_FAIL:
        case CREATE_MODULECLE_CONTENT_FAIL:
        case UPDATE_MODULECLE_CONTENT_FAIL:
        case DELETE_MODULECLE_CONTENT_FAIL:
        case REORDER_MODULECLE_CONTENTS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        default:
            return state;
    }
}
